import React from "react";
import { collection, query, where, doc, updateDoc, getDocs } from "firebase/firestore";
import { db } from "../Firebase/firebase";
import { UserAuth } from "../Firebase/authcontext";

export function FriendAcceptModal(props) {
  const { user } = UserAuth();

  return (
    <table
      style={{
        backgroundColor: "white",
        borderRadius: "20px",
        marginTop: "20px",
        width: "100%",
      }}
    >
      <tbody>
        <tr style={{ padding: "20px" }}>
          <td style={{ padding: "20px" }}>
            <img
              style={{ width: "50px", borderRadius: "50%" }}
              src={props.img}
              alt="User"
            />
          </td>
          <td style={{ padding: "20px" }}>
            <h6>{props.name}</h6>
            <h6>{props.position}</h6>
          </td>
          <td style={{ padding: "20px" }}>
              <button onClick={()=>{
                window.location.href=`/friend-chat/${props.uid}`
              }}
                style={{
                  color: "#0070ff",
                  borderRadius: "5px",
                  border: "1px solid #0070ff",
                  padding: "5px 10px",
                }}
              >
                <b>Chat</b>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
